import styled from "@emotion/styled";
import {
  COLOR_GREEN_BORDER,
  COLOR_GREEN_CHECKBOX_HOVER,
  MOBILE_SCREEN,
} from "../../../components/theme";
import ErrorMessage from "../../../components/Error";

export const StyledOptionContainer = styled.div<{ isChecked: boolean }>`
  display: grid;
  grid-template-columns: 32px 1fr;
  align-items: center;
  padding: 24px;
  gap: 8px;
  margin: 4px 0;
  user-select: none;
  border-radius: 8px;
  box-shadow: ${({ isChecked }) =>
    isChecked ? `inset 0 0 0 1px ${COLOR_GREEN_BORDER}` : "none"};
  background-color: ${({ isChecked }) =>
    isChecked ? COLOR_GREEN_CHECKBOX_HOVER : "transparent"};
  ${MOBILE_SCREEN} {
    padding: 8px;
  }
`;

export const MissingAnswerMessageContainer = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
`;

export const QuestionOptionsListContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;

export const QuestionOptionContainer = styled.div`
  width: 100%;
`;

export const StyledErrorMessage = styled(ErrorMessage)`
  text-align: left;
`;
